function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 271.25 47.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logos_Vecto",
    "data-name": "Logos Vecto"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2-2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.54,29.11c-.34.05-.53-.21-.73-.39-.88-.81-1.79-1.6-2.59-2.49-1.11-1.21-2.14-2.48-3.14-3.79S9,19.6,8.06,18.11a23.43,23.43,0,0,1-2.14-4,8.53,8.53,0,0,1-.61-2.73c0-.33,0-.66,0-1a9.7,9.7,0,0,1,.93-4.27A9.55,9.55,0,0,1,7.89,3.59,10.33,10.33,0,0,1,12.53.52,9.82,9.82,0,0,1,15.47,0a11.32,11.32,0,0,1,3.28.37A10.23,10.23,0,0,1,22.14,2a10.58,10.58,0,0,1,4.27,9.68,10.19,10.19,0,0,1-.74,2.83,21,21,0,0,1-2.59,4.35c-1,1.38-2,2.79-3,4.22a19.26,19.26,0,0,0-2.21,4.48A12.81,12.81,0,0,0,17.54,29.11Zm.7-19a2.28,2.28,0,0,0-2.18-2.31,2.42,2.42,0,0,0-2.32,2.23A2.38,2.38,0,0,0,16,12.36,2.28,2.28,0,0,0,18.24,10.13Z",
    style: {
      fill: "#f49f37"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.91,
    cy: 31.24,
    r: 5.91,
    style: {
      fill: "#ffd237"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.27,
    cy: 39.25,
    r: 8.17,
    style: {
      fill: "#406cae"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.95,
    cy: 19.13,
    r: 11.12,
    style: {
      fill: "#e74870"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M81,17V33.71H77.65V22l-4.3,11.69H70.42l-4.3-11.64V33.71H62.74V17h4.1l5.1,12.61,5-12.61Z",
    style: {
      fill: "#12263f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.37,20.41l3.62,9,3.37-9h3.72L88.94,40.05H85.19l3-6.72L82.6,20.41Z",
    style: {
      fill: "#12263f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.66,31.47a4.61,4.61,0,0,1-1.92,1.75,6.67,6.67,0,0,1-3.1.66,8,8,0,0,1-3.22-.61,5.4,5.4,0,0,1-2.26-1.77,5.07,5.07,0,0,1-1-2.69h3.6a2.78,2.78,0,0,0,.83,1.72,2.6,2.6,0,0,0,1.89.69,2.19,2.19,0,0,0,1.62-.57,1.94,1.94,0,0,0,.56-1.45,1.91,1.91,0,0,0-.45-1.31,3.45,3.45,0,0,0-1.16-.83,19.63,19.63,0,0,0-1.92-.72,19.47,19.47,0,0,1-2.59-1,5,5,0,0,1-1.72-1.5,4.34,4.34,0,0,1-.71-2.57,4.18,4.18,0,0,1,1.58-3.45,6.47,6.47,0,0,1,4.16-1.26,6.56,6.56,0,0,1,4.29,1.3A4.83,4.83,0,0,1,110,21.27h-3.65a2.58,2.58,0,0,0-.76-1.5,2.42,2.42,0,0,0-1.71-.59,2.24,2.24,0,0,0-1.51.5,2,2,0,0,0-.13,2.66,3.37,3.37,0,0,0,1.12.81,17,17,0,0,0,1.87.69,28.33,28.33,0,0,1,2.65,1.08,4.66,4.66,0,0,1,1.74,1.52,4.43,4.43,0,0,1,.72,2.64A4.64,4.64,0,0,1,109.66,31.47Z",
    style: {
      fill: "#12263f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.57,21.72A6,6,0,0,1,135,26v7.73h-3.36V26.36a3.31,3.31,0,0,0-.78-2.36,2.82,2.82,0,0,0-2.15-.83,3,3,0,0,0-2.26.89,3.64,3.64,0,0,0-.84,2.59v7.06h-3.36V26.36a3.31,3.31,0,0,0-.78-2.36,2.82,2.82,0,0,0-2.15-.83,3,3,0,0,0-2.26.89,3.64,3.64,0,0,0-.84,2.59v7.06h-3.38V20.41h3.38v2.52a4.17,4.17,0,0,1,1.67-2,4.88,4.88,0,0,1,2.66-.71,5,5,0,0,1,2.79.77,4.62,4.62,0,0,1,1.79,2.2A5.1,5.1,0,0,1,127,21a5.47,5.47,0,0,1,6.61.7Z",
    style: {
      fill: "#12263f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,21a4.35,4.35,0,0,1,1.71,2.14V20.41h3.36v13.3h-3.36V30.93A4.46,4.46,0,0,1,146,33.08a5.1,5.1,0,0,1-2.88.8,5.63,5.63,0,0,1-3-.82A5.52,5.52,0,0,1,138,30.7a8.27,8.27,0,0,1-.75-3.64,8.3,8.3,0,0,1,.75-3.64,5.52,5.52,0,0,1,2.11-2.36,5.63,5.63,0,0,1,3-.82A5.09,5.09,0,0,1,146,21Zm-4.37,3.2a4,4,0,0,0-1,2.83,4,4,0,0,0,1,2.82,3.65,3.65,0,0,0,5.08,0,3.87,3.87,0,0,0,1-2.8,3.91,3.91,0,0,0-1-2.82,3.61,3.61,0,0,0-5.08,0Z",
    style: {
      fill: "#12263f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.54,21a5.23,5.23,0,0,1,2.74-.73v3.62h-1c-2.48,0-3.72,1.16-3.72,3.46v6.41h-3.39V20.41h3.39V23A5.64,5.64,0,0,1,159.54,21Z",
    style: {
      fill: "#12263f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.26,30.81v2.9h-1.78a4.91,4.91,0,0,1-3.42-1.08,4.68,4.68,0,0,1-1.19-3.6V23.27H163V20.41h1.85V17.12h3.39v3.29h3v2.86h-3v5.81a1.84,1.84,0,0,0,.38,1.34,1.79,1.79,0,0,0,1.3.39Z",
    style: {
      fill: "#12263f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.31,16.76v12a5.14,5.14,0,0,1-1.35,3.8,5.07,5.07,0,0,1-3.76,1.36,5.62,5.62,0,0,1-4.11-1.49,5.69,5.69,0,0,1-1.51-4.25h3.34a3.17,3.17,0,0,0,.54,2,1.88,1.88,0,0,0,1.59.7,1.73,1.73,0,0,0,1.42-.56,2.44,2.44,0,0,0,.46-1.55v-12Z",
    style: {
      fill: "#12263f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.91,21.06a6,6,0,0,1,2.44,2.36,7.24,7.24,0,0,1,.88,3.64,7.18,7.18,0,0,1-.88,3.63,6.15,6.15,0,0,1-2.44,2.36,7.77,7.77,0,0,1-7,0,6.09,6.09,0,0,1-2.44-2.36,7.18,7.18,0,0,1-.89-3.63,7.24,7.24,0,0,1,.89-3.64,6,6,0,0,1,2.44-2.36,7.86,7.86,0,0,1,7,0ZM190,24.17a4,4,0,0,0-1,2.89A4,4,0,0,0,190,30a3.39,3.39,0,0,0,4.81,0,4,4,0,0,0,1-2.89,4,4,0,0,0-1-2.89,3.39,3.39,0,0,0-4.81,0Z",
    style: {
      fill: "#12263f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.36,20.41v13.3H211V31a4.23,4.23,0,0,1-1.74,2.1,5.13,5.13,0,0,1-2.8.76,4.72,4.72,0,0,1-3.68-1.51,6.09,6.09,0,0,1-1.36-4.23V20.41h3.36v7.35a3.51,3.51,0,0,0,.81,2.46,2.9,2.9,0,0,0,2.21.88,3,3,0,0,0,2.33-.94,3.82,3.82,0,0,0,.87-2.69V20.41Z",
    style: {
      fill: "#12263f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.79,21a5.23,5.23,0,0,1,2.74-.73v3.62h-1c-2.49,0-3.73,1.16-3.73,3.46v6.41h-3.38V20.41h3.38V23A5.72,5.72,0,0,1,222.79,21Z",
    style: {
      fill: "#12263f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,21.73A6.13,6.13,0,0,1,240.37,26v7.73H237V26.36a3.47,3.47,0,0,0-.82-2.46A2.91,2.91,0,0,0,234,23a3,3,0,0,0-2.31.93,3.86,3.86,0,0,0-.86,2.69v7.06H227.4V20.41h3.39v2.66a4.27,4.27,0,0,1,1.74-2.1,5.21,5.21,0,0,1,2.8-.75A4.7,4.7,0,0,1,239,21.73Z",
    style: {
      fill: "#12263f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.74,27.71H246a3.7,3.7,0,0,0,1,2.62,3.09,3.09,0,0,0,2.21.84,3.19,3.19,0,0,0,2-.58,2.5,2.5,0,0,0,1-1.56h3.58a5.75,5.75,0,0,1-1.13,2.5,5.9,5.9,0,0,1-2.22,1.73,7.2,7.2,0,0,1-3,.62,7,7,0,0,1-3.46-.83,5.81,5.81,0,0,1-2.35-2.36,7.49,7.49,0,0,1-.84-3.63,7.55,7.55,0,0,1,.84-3.64,5.69,5.69,0,0,1,2.35-2.36,7.11,7.11,0,0,1,3.46-.82,6.92,6.92,0,0,1,3.44.82,5.65,5.65,0,0,1,2.28,2.24,6.52,6.52,0,0,1,.81,3.26A6.42,6.42,0,0,1,255.74,27.71Zm-4.14-4a3.27,3.27,0,0,0-2.27-.84,3.34,3.34,0,0,0-2.31.84,3.43,3.43,0,0,0-1,2.47h6.46A3,3,0,0,0,251.6,23.75Z",
    style: {
      fill: "#12263f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.54,20.41l3.63,9,3.36-9h3.72l-8.14,19.64h-3.74l3-6.72-5.6-12.92Z",
    style: {
      fill: "#12263f"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.83b6cac8.svg";
export { ForwardRef as ReactComponent };